<!-- 订单取消弹框 -->
<template>
    <el-dialog center append-to-body :visible.sync="dialogVisible" width="30%">
        <div class="lineBox">
            <p class="lineBoxP1"> <i class="el-icon-info icon1"></i>取消说明 <span>*</span></p>
            <!-- <p>该订单尚未确认，可免费取消</p> -->
            <p>取消政策如下：</p>
            <div class="cancelBox">
                <span v-for="(item, index) in datas.modifyOrderCancelDetailResultList" :key="index">
                    <span class="cancelBoxSpan1">{{ item.productName }} </span> {{ item.cancellationPolicyDescription }}
                    <span v-if="item.cancelFees">取消金额：{{
                        item.cancelFees }}¥</span>
                </span>
            </div>
        </div>
        <div class="lineBox">
            <p class="lineBoxP1"> <i class="el-icon-info icon1"></i>取消原因</p>
            <div class="titleBox">
                <div class="titleBtn" v-for="item in titleList" :key="item">
                    {{ item }}
                </div>
            </div>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-tooltip content="与商家沟通取消费用" placement="bottom" effect="light">
                <el-button style="color: #ED7046;" size="small" @click="cancelClick">取消订单</el-button>

            </el-tooltip>
        </span>
    </el-dialog>
</template>
<script>

import OrderApi from "@/components/Api/order";
export default {
    components: {},
    data() {
        return {
            dialogVisible: false,
            titleList: ['行程取消', '信息填错', '换个产品', '其它'],
            datas: {},
            orderChildrenId: '',
        }
    },
    computed: {},
    watch: {},
    methods: {
        initClick(orderChildrenId) {
            this.orderChildrenId = orderChildrenId
            console.log(orderChildrenId, '撒打算打算的');
            let obj = {
                orderChildrenId,
            }
            new OrderApi('order').paidModifyOrderCancel(obj).then(res => {
                if (res.status == 200) {
                    this.datas = res.data
                    console.log(this.datas, '坎坎坷坷看看');
                } else {
                    this.$message({
                        type: 'warning',
                        message: res.statusText
                    });
                }
            })
            this.dialogVisible = true
        },
        //订单取消
        cancelClick() {
            let price = 0
            this.datas.modifyOrderCancelDetailResultList.forEach(item => {
                price += Number(item.cancelFees)
            })
            this.$confirm(`您确定取消订单吗? 取消金额为${price}¥`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                new OrderApi('order').orderHasBeenPaidAndCancelled(this.orderChildrenId).then(res => {
                    if (res.status == 200) {
                        this.$message({
                            type: 'success',
                            message: '取消成功!'
                        });
                        this.dialogVisible = false
                    } else {
                        this.$message({
                            type: 'warning',
                            message: res.statusText
                        });
                    }
                })

            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消操作'
                });
            });
        }
    },
    created() {

    },
    mounted() {

    },
}
</script>
<style lang='scss' scoped>
.lineBox {
    margin-bottom: 0.2rem;

    .cancelBox {
        border: 1px solid #EBEEF4;
        padding: 0.05rem 0.1rem;
        width: 3rem;
        border-radius: 5px;

        .cancelBoxSpan1 {
            color: #CE5F3A;
            font-weight: bold;
        }

    }

    &:nth-last-child(1) {
        margin-bottom: 0;
    }

    p {
        margin-bottom: 0.05rem;
    }

    .lineBoxP1 {
        font-weight: bold;
        margin-bottom: 0.15rem;

        span {
            color: red;
        }
    }

    .titleBox {
        display: flex;
        align-items: center;

        .titleBtn {
            width: 0.8rem;
            height: 0.3rem;
            border-radius: 5px;
            color: gray;
            border: 1px solid gray;
            text-align: center;
            line-height: 0.3rem;
            margin-right: 0.1rem;
            cursor: pointer;

            &:nth-last-child(1) {
                margin-right: 0;
            }
        }
    }

    .icon1 {
        color: red;
        margin-right: 0.1rem;
    }
}
</style>